export const sxSelect = {
    background: "white",
    boxShadow: "none",
    ".MuiOutlinedInput-notchedOutline": { border: "none" },
    fontWeight: 400,
    fontSize: "14px",
    width: "100%",
    height: "30px",
    padding: "0 3px",
    overflow: "auto", // Garante que o conteúdo não transborde do Select
    textOverflow: "ellipsis", // Adiciona reticências para texto longo
    whiteSpace: "nowrap", // Evita que o texto quebre em múltiplas linhas
    "& .MuiSelect-icon": {
        color: "#929292"
    },
    '& .MuiSelect-select': {
        height: '24px'
    }
}

export const sxMenuPaper = {
    maxHeight: "250px",
    overflowY: "auto", // Permite rolagem caso as opções excedam o limite
    marginTop: "5px", // Adiciona um pequeno deslocamento entre o Select e o menu
    "& .MuiMenuItem-root": {
        maxWidth: "100%", // Respeita a largura do Select
        overflow: "hidden", // Evita transbordamento do texto
        textOverflow: "ellipsis", // Adiciona reticências ao texto longo
        whiteSpace: "nowrap" // Evita quebra de linha
    },
    "& .Mui-selected": {
        backgroundColor: "#9d56b93f !important"
    },
    "& .MuiChecbox-root": {
        padding: "0px !important",
        color: "#000 !important"
    }
}

export const sxChipSelect = {
    backgroundColor: '#be00ff2e',
    border: '1px solid #9500c8',
    paddingLeft: "0px",
    margin: "0px",
    fontSize: "12px",
    color: "#000",
    borderRadius: "6px",
    height: "24px",
    "& .MuiChip-deleteIcon": {
        color: "#000"
    },
    "& .MuiChip-label": {
        fontSize: '12px',
        padding: "0px 4px"
    }
}

export const sxBoxRenderValue = {
    display: "flex",
    flexWrap: "wrap",
    gap: "5px"
}
